import React from 'react';
import TaskCreator from './TaskCreator';

function App() {
  return (
    <div className="App">
      <TaskCreator />
    </div>
  );
}

export default App;